import React from 'react';
import './index.scss';
import Section from '../../../../../../../../design/1/js/templates/atoms/section';
import AsyncLoader from '../../../../../../../../design/1/js/templates/molecules/async-loader';
import { AsyncWidgetProps } from '../../../../../base/ts/lib/AsyncWidgetProps';
import StatusMessageVariation
    from '../../../../../../../../design/1/js/templates/molecules/status-message/lib/StatusMessageVariation';
import SavingPlanInfoItem from "../../../../../simulation/ts/lib/savingPlan/SavingPlanInfoItem";
import Table from "../../../../../../../../design/1/js/templates/molecules/table";
import TableHead from "../../../../../../../../design/1/js/templates/atoms/table-head";
import TableBody from "../../../../../../../../design/1/js/templates/atoms/table-body";
import TableHeightRow from "../../../../../../../../design/1/js/templates/atoms/table-height-row";

const SavingPlanOverviewSection = ({ action }: AsyncWidgetProps) => {
    const baseClassName = 'm-saving-plan-overview-section';

    return (
        <Section className={`${baseClassName}`}>
            <AsyncLoader
                action={action}
                renderContent={lazyChildren => (
                    <>
                        {lazyChildren}
                    </>
                )}
                variation={StatusMessageVariation.Homepage}
            >
                {(infos: SavingPlanInfoItem[]) => {
                    return (
                        <div className={`${baseClassName}__wrapper d-print-none`}>
                            <Table>
                                <TableHead>
                                    <div className={'col-4 offset-4'}>{window.sv_resource.get('plf_saving_plan_overview_part_insured')}</div>
                                    <div className={'col-4'}>{window.sv_resource.get('plf_saving_plan_overview_part_company')}</div>
                                </TableHead>
                                <TableBody>
                                    {infos.map((info, index) => (
                                        <TableHeightRow key={`row-${index.toString()}`}>
                                            <div className={'col-4 plan-info-col name-col'}>{window.sv_resource.get('plf_saving_plan_overview_prefix')} {info.name}</div>
                                            <div className={'col-4 plan-info-col'}>{info.percentageEmployee} %</div>
                                            <div className={'col-4 plan-info-col'}>{info.percentageCompany} %</div>
                                        </TableHeightRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    );
                }}
            </AsyncLoader>
        </Section>
    );
};

export default SavingPlanOverviewSection;
